export const fetchAudioAsFile = async (url: string, name?: string): Promise<File> => {
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`Failed to fetch audio: ${response.status}`);
    }
    const blob = await response.blob();
    const mimeType = blob.type.startsWith("audio/") ? blob.type : "audio/mpeg";
    const extension = mimeType === "audio/mpeg" ? ".mp3" : ".wav";
    const fileName = name !== undefined ? `${name}${extension}` : `preview${extension}`;
    return new File([blob], fileName, { type: mimeType });
};
